<div class="question-container">
    <h1>{{ question() }}</h1>
    <p>{{ explanation() }}</p>
</div>
